export interface ISKUDeviceData {
  deviceType: string;
  model: string[];
  isPT?: boolean;
  panTiltType?: string;
}

export const panTiltTypeOptions = [
  { value: "CH4-UCv2", label: "CH4-UCv2" },
  { value: "JSys", label: "JSys" },
  { value: "JSysV2", label: "JSysV2" },
];

export interface ISKUForm {
  skuNumber: string;
  skuName: string;
  category: string;
  nodeCount: number | "";
  password?: string;
  hasRecordVideo?: boolean;
  skuData: ISKUDeviceData[];
}

export const defaultSKUForm: ISKUForm = {
  skuNumber: "",
  skuName: "",
  category: "",
  nodeCount: "",
  password: "",
  hasRecordVideo: true,
  skuData: [],
};

export const skuFormRules = {
  skuNumber: {
    required: true,
  },
  skuName: {
    required: true,
  },
  category: {
    required: true,
  },
  nodeCount: {
    required: true,
    min: 1,
  },
  skuData: {
    deviceType: {
      required: true,
    },
    model: {
      required: true,
    },
    password: {
      minLength: 8,
    },
    panTiltType: {
      requiredWhenPT: true,
    },
  },
};

export const modelLabelMap: Record<string, string> = {
  gasleak: "Leak",
  liquidleak: "Liquid Leak",
  firesmoke: "Fire/Smoke",
  hardhat: "Hard Hat",
  agg: "Gate Guard",
  tlm: "Tank Level",
};

export const skuCategoryOptions = [
  { value: "System", label: "System" },
  { value: "Accessory", label: "Accessory" },
  { value: "Peripheral", label: "Peripheral" },
];
